import angular from 'angular';
import routers from './routers.js';
import listBannerCtrl from './listBannerCtrl.js';
import balanceSheetListPage from './view/balanceSheetPage.html';
import incomeStatementListPage from './view/incomeStatementPage.html';
import cashFlowStatementListPage from './view/cashFlowStatementPage.html';
import balanceSheetListPageCtrl from './balanceSheetCtrl';
import incomeStatementListPageCtrl from './incomeStatementListPageCtrl';
import cashFlowStatementListPageCtrl from './cashFlowStatementListPageCtrl';
import tableQueryConfig from './tableQueryConfig';

export default angular
  .module('declaration.corporateIncomeTax.smallBusinessGuidelines', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config);
      });
    },
  ])
  .controller('listBannerCtrl', listBannerCtrl)
  .controller('balanceSheetListPageCtrl', balanceSheetListPageCtrl)
  .controller('incomeStatementListPageCtrl', incomeStatementListPageCtrl)
  .controller('cashFlowStatementListPageCtrl', cashFlowStatementListPageCtrl)
  .value('tableQueryConfig', tableQueryConfig)
  .component('balanceSheet', {
    template: balanceSheetListPage,
    controller: 'balanceSheetListPageCtrl',
  })
  .component('incomeStatement', {
    template: incomeStatementListPage,
    controller: 'incomeStatementListPageCtrl',
  })
  .component('cashFlowStatement', {
    template: cashFlowStatementListPage,
    controller: 'cashFlowStatementListPageCtrl',
  }).name;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/smallBusinessGuidelines/index.js